import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Badge,
  Image as RImage,
  Button,
  Accordion,
  Navbar,
} from "@themesberg/react-bootstrap";
import Image from "./image";
import { Divider, IconButton, Stack, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { CgHome } from "react-icons/cg";
import { connect, useDispatch, useSelector } from "react-redux";

// import stblogo from "../assets/img/icons/InvestvertexWhite.png";
import ipusalogo from "../assets/img/buckzy.jpg";
import ipusalogoWhite from "../assets/img/buckzy.jpg";
import HomeIcon from "../assets/img/sideicon/home.svg";
import AdminIcon from "../assets/img/sideicon/adminstration.svg";
import TransIcon from "../assets/img/sideicon/transaction.svg";
import ProfileIcon from "../assets/img/sideicon/profile.svg";
import liquidityIcon from "../assets/img/sideicon/liquidity.svg";
import ExchangeIcon from "../assets/img/sideicon/exchange.svg";
import BankIcon from "../assets/img/sideicon/bank.svg";
import LevelIcon from "../assets/img/sideicon/level.svg";
import CurrencyIcon from "../assets/img/sideicon/currency.svg";
import InvoiceIcon from "../assets/img/sideicon/invoice.svg";
import ClientsIcon from "../assets/img/sideicon/clients.svg";
import SendersIcon from "../assets/img/sideicon/senders.svg";
import ConfigIcon from "../assets/img/sideicon/configuration.svg";
import FeesIcon from "../assets/img/sideicon/fees.svg";
import ReceiversIcon from "../assets/img/sideicon/receivers.svg";
import SupportIcon from "../assets/img/sideicon/support.svg";
import BusinessIcon from "../assets/img/sideicon/business.svg";
import IndividualIcon from "../assets/img/sideicon/individual.svg";
import KycIcon from "../assets/img/sideicon/kyc.svg";
import supportChatIcon from "../assets/img/sideicon/supportChat.svg";
import OutwardIcon from "../assets/img/sideicon/outward.svg";
import InwardIcon from "../assets/img/sideicon/inward.svg";
import DepositIcon from "../assets/img/sideicon/deposit.svg";
import PortalIcon from "../assets/img/sideicon/portal.svg";
import TransactionsIcon from "../assets/img/sideicon/transactions.svg";
import PortalUsersIcon from "../assets/img/sideicon/portalUsers.svg";
import RedemptionIcon from "../assets/img/sideicon/availableRedemption.svg";
import FeesLogo from "../assets/img/sideicon/feeslogo.svg";
import CustomerLogo from "../assets/img/sideicon/customer.svg";
import { Routes } from "../routes";
import { getStatus } from "../redux/actions/kybActions";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toggleSidebar, showSidebar } from "../redux/actions/config";
import Scrollbar from "./Scrollbar";

const Sidebar = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { showSidebar: isShowSidebar } = useSelector(
    (state) => state.configReducer
  );


  const matches = useMediaQuery("(min-width:768px)");

  useEffect(() => {
    dispatch(showSidebar());
  }, [matches, dispatch]);

  const { pathname } = location;
  console.log(pathname);
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, image, children = null, type = "" } = props;
    // Check if current pathname matches the eventKey pattern
    const isActive = pathname.indexOf(eventKey) !== -1;
    const defaultKey = isActive ? eventKey : "";

    return (
      <Accordion 
        as={Nav.Item} 
        defaultActiveKey={defaultKey}
        key={`${eventKey}-${pathname}`} // Force re-render when pathname changes
      >
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button
            as={Nav.Link}
            className="d-flex justify-content-between border-none box-shad-none align-items-center"
          >
            <span>
              {image ? (
                <RImage
                  src={image}
                  width={20}
                  height={20}
                  className="sidebar-icon svg-icon"
                />
              ) : null}
              <span className="sidebar-text light_color colr font-fam">
                {title}
              </span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level pt-0">
            <Nav
              style={{ marginLeft: type === "nested" ? "2rem" : "" }}
              className="flex-column bgchild  "
            >
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
      subTitle = "",
    } = props;
    const classNames = badgeText
      ? "d-flex justify-content-start   align-items-center justify-content-between "
      : "";
    let navItemClassName;
    // if (link === '/') {
    navItemClassName = pathname === link ? "active" : "";
    // } else {
    //   navItemClassName = pathname.includes(link) ? 'active' : '';
    // }
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span className="d-flex">
            {icon ? (
              <span className="sidebar-icon">
                <CgHome size="1em" />{" "}
              </span>
            ) : null}
            {image ? (
              <RImage
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            ) : null}
            <span className="d-flex row">
              <span className="sidebar-text light_color font-fam">{title}</span>
              <span className="light_color font-11">{subTitle}</span>
            </span>
          </span>
          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md notification-count ms-2"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  let sidebarContent = (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none"
      >
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <Scrollbar
          className={`collapse ${showClass} sidebar d-md-block primary_color text-white ${
            !isShowSidebar ? "sidebar-hide" : ""
          }`}
        >
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center"></div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0 ">
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: "center",
                  mb: 5,
                }}
              >
                <Image
                  src={ipusalogoWhite}
                  sx={{
                    width: "200px",
                  }}
                />
                {/* {matches && (
                  <IconButton
                    aria-label="toggle passphrase visibility"
                    onClick={() => {
                      dispatch(toggleSidebar());
                    }}
                    edge="end"
                    sx={{
                      color: "white",
                    }}
                  >
                    {<KeyboardArrowLeftIcon />}
                  </IconButton> */}
              </Stack>
                <NavItem
                  title="KYC Submitted"
                  eventKey="kyc-submitted"
                  link={Routes.KycSubmitted.path}
                  image={KycIcon}
                />
            </Nav>
          </div>
        </Scrollbar>
      </CSSTransition>
    </>
  );
  return sidebarContent;
};

function mapStateToProps({ kybReducer, authReducer }) {
  const { status } = kybReducer;
  const { userRole, isSingleWallet } = authReducer;
  return {
    data: status.data,
    userRole,
    isSingleWallet,
  };
}

const actionCreators = {
  getStatus,
};

export default connect(mapStateToProps, actionCreators)(Sidebar);


